import React from 'react';
import { LineChart } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function ScoreTradePage() {
  const module = getModule('scoretrade')!;
  return (
    <ModulePageLayout module={module} Icon={LineChart}>
      <Section title="Your Financial Reputation, Made Tradeable">
        <p className="text-gray-700 leading-relaxed">
          ScoreTrade is a proprietary scoring system that turns your financial reputation into a tradeable
          identity. Lenders publish what scores they'll accept and at what rates; borrowers with qualifying
          scores apply directly — better scores command better rates.
        </p>
      </Section>

      <Section title="What Makes Up Your Score">
        <FeatureGrid
          items={[
            { title: 'Cash Flow Health Score', body: 'Measures the stability of your income and expenses over time.' },
            { title: 'Asset Backing Ratio', body: 'The proportion of your obligations backed by real assets.' },
            { title: 'Repayment Performance Score', body: 'Your historical track record of paying on time.' },
            { title: 'Customer Rating & Reputation', body: 'Peer-reviewed trustworthiness, combined into a composite reputation score.' },
          ]}
        />
      </Section>

      <Section title="The Marketplace">
        <p className="text-gray-700 leading-relaxed mb-4">
          When your score qualifies, a lender match creates a smart contract governing the loan terms —
          recorded on-chain with a contract hash. Every score-related action is logged in a full audit trail
          for regulatory compliance.
        </p>
        <div className="bg-violet-50 border border-violet-200 rounded-xl p-5">
          <p className="text-violet-900 text-sm font-medium">
            External financial data sources also feed into your score, enriching its accuracy beyond what
            Bankably alone can see.
          </p>
        </div>
      </Section>
    </ModulePageLayout>
  );
}
